export default __webpack_public_path__ + "static/media/gimbal-icon-on-bright.1e2560a0.png";